export const GET_NAMES = "GET_NAMES";
export const ADD_NAME = "ADD_NAME";
export const DELETE_NAME = "DELETE_NAME";
export const LOAD_ING = "LOAD_ING";
export const GET_LENGTH = "GET_LENGTH";

// Login & Register ActionsTypes
export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const LOGIN_ACCOUNT = "LOGIN_ACCOUNT";
